function s(n, c, e) {
  const d = n.map(e), i = c.map(e);
  return {
    added: c.filter((r) => !d.includes(e(r))),
    removed: n.filter((r) => !i.includes(e(r)))
  };
}
export {
  s as getArrayDifferenceBy
};
